<template>
  <div>
    <AddFormItem
      :bp="bp"
      :fields="fields"
      :custom_icon="custom_icon"
      @submit="submit_action"
    />
  </div>
</template>
  
<script>
  import AddFormItem from '@/components/bpcreator/model/AddFormItem';
  export default {
    components: {
      AddFormItem
    },
      
    name: 'AddModel',
      
    props: {
      bp: {default: () => ({})},
      field: {default: () => ({})},
      custom_icon: {default: 'mdi-plus'},
    },
      
    data: () => ({
      show_modal_dialog: false,
      loading: false,
      form: null,
    }),
      
    computed: {
      fields() {
        let res = []
        for (let item of this.bp.new_model_property().props) {
          res.push([
            {
              ...item,
              'cols': 4,
              'items': item && item.items_funct ? (item.items_funct)(this.bp) : [],
              'value': item && item.value_funct ? (item.value_funct)(this.field,this.bp.lang) : (this.field || {})[item.id],
            }
          ])
        }
        return res;
      }
    },
      
    mounted() {
    },
      
    methods: {

      open_dialog() {
        this.show_modal_dialog = true;
      },

      hide_dialog() {
        this.show_modal_dialog = false;
      },

      submit_action(form) {
        //Override and conserve field values, with the new ones
        let res = {[form.id]: {...this.field,...form}};
        // Id property is not going here, belongs to the key of this values, so we have to delete from here
        delete res[form.id].id;
        this.$emit('update',res,form.id);
        this.hide_dialog();
      },
    },
  
    watch: {
    },
  }
</script>